export default {"src":"/_next/static/media/feature-3.3df599d3.svg","height":198,"width":246};